import * as Dialog from '@radix-ui/react-dialog';
import React from 'react';
import toast from 'react-hot-toast';

import { createCustomerPortalLocation, type CustomerPortalCreatedLocation } from './models';
import { CustomerPortalCreateLocationForm } from './CustomerPortalCreateLocationForm';
import { getDisplayError } from '../../../utils/get-display-error';
import { useTranslation } from '../../../contexts/translation-context';
import { captureException } from '@sentry/react';
import { useCustomerPortalCustomer } from '../CustomerPortalCustomerContext';

export interface ILocationPreviewDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onCreated: (data: CustomerPortalCreatedLocation) => void;
}

export const CustomerPortalCreateLocationDialog: React.FC<ILocationPreviewDialogProps> = (props) => {
  const { isOpen, setIsOpen, onCreated } = props;
  const { customer } = useCustomerPortalCustomer();
  const { i18n } = useTranslation();

  return (
    <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
      <Dialog.Portal>
        <Dialog.Overlay className="dialog-overlay" />
        <Dialog.Content className="dialog-content">
          <Dialog.Title className="heading-one mb-4">{i18n('customerPortal.locations.newLocation')}</Dialog.Title>

          <CustomerPortalCreateLocationForm
            onCancel={() => setIsOpen(false)}
            onSubmit={async (values) => {
              try {
                const locationData = await createCustomerPortalLocation({
                  customerId: customer.id,
                  ...values,
                });
                onCreated(locationData);
                toast.success(i18n('customerPortal.locations.locationCreated'));
              } catch (err: any) {
                captureException(err);
                toast.error(
                  i18n('customerPortal.locations.couldNotCreateLocation', {
                    error: getDisplayError(err),
                  }),
                );
              }
            }}
          />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
